import { render } from "./hub-widget.vue?vue&type=template&id=03f44072&scoped=true"
import script from "./hub-widget.vue?vue&type=script&lang=ts"
export * from "./hub-widget.vue?vue&type=script&lang=ts"

import "./hub-widget.vue?vue&type=style&index=0&id=03f44072&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03f44072"

export default script